import styled from "styled-components";
import iconBasketball from "../../assets/images/icon-basketball.svg";
import iconVolleyball from "../../assets/images/volleyball-icon.svg";
import iconTennis from "../../assets/images/tennis-icon.svg";
import iconFootball from "../../assets/images/football-icon.svg";
import iconMixed from "../../assets/images/mixed-icon.svg";

export const TitleWithIcon = styled.div`
  align-items: center;
  display: flex;
  margin: -2px 30px 0 0;
  width: auto;
`;

export const Icon = styled.div`
  height: 30px;
  margin-right: 10px;
  width: 30px;

  ${({ icon }) => icon === "basketbol" && `background-image: url(${iconBasketball})`};
  ${({ icon }) => icon === "voleybol" && `background-image: url(${iconVolleyball})`};
  ${({ icon }) => icon === "tenis" && `background-image: url(${iconTennis})`};
  ${({ icon }) => icon === "futbol" && `background-image: url(${iconFootball})`};
  ${({ icon }) => icon === "mixed" && `background-image: url(${iconMixed})`};
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.color18};
  font-size: 36px;
  margin: 0;
`;
